import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const DataOutlineIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="DataOutlineIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/data/outline">
            <path
                fill="none"
                d="M12.0011 4.20996C14.3701 4.21005 16.6857 4.91389 18.6544 6.23145C20.6233 7.54922 22.1574 9.42207 23.0607 11.6123C23.1534 11.862 23.1532 12.137 23.0607 12.3867C22.1574 14.577 20.6234 16.4498 18.6544 17.7676C16.6856 19.0853 14.3702 19.789 12.0011 19.7891C9.63185 19.7891 7.31577 19.0854 5.34681 17.7676C3.37786 16.4498 1.84388 14.577 0.940562 12.3867C0.847999 12.137 0.847876 11.862 0.940562 11.6123C1.84389 9.42206 3.37789 7.54922 5.34681 6.23145C7.3157 4.91379 9.63198 4.20996 12.0011 4.20996ZM12.0001 8.02441C9.80468 8.02441 8.02468 9.80458 8.02455 12C8.02455 14.1955 9.8046 15.9756 12.0001 15.9756C14.1956 15.9755 15.9757 14.1955 15.9757 12C15.9756 9.80461 14.1955 8.02447 12.0001 8.02441Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
            </path>
        </g>
    </SvgIcon>
)
